import { encodeSetChannelRoleOverrides } from '../utils/encodeSetChannelRoleOverrides';
export async function setChannelPermissionOverrides(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const [contractParams, signer] = fnArgs;
    if (!spaceDapp) {
        throw new Error('spaceDapp is required');
    }
    const space = spaceDapp.getSpace(contractParams.spaceNetworkId);
    if (!space) {
        throw new Error(`Space with spaceId "${contractParams.spaceNetworkId}" is not found.`);
    }
    const { functionHashForPaymasterProxy, callData } = encodeSetChannelRoleOverrides({
        space,
        contractParams,
    });
    return smartAccount.sendUserOp({
        toAddress: [space.Roles.address],
        callData: [callData],
        signer,
        spaceId: contractParams.spaceNetworkId,
        functionHashForPaymasterProxy,
    });
}
